import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

import Gallery from "../../../../../components/gallery/gallery.js";

import sweetaichat1 from "../../../../../../assets/sweetaichat1.png";
import sweetaichat2 from "../../../../../../assets/sweetaichat2.png";

export default function SweetAiChat({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="SweetAiChat" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="sweetAiChatPanel">
            <Trans i18nKey="sweetAiChatDetails" />

            <h2 className="text-center titles text-pink-200">{t("technologies")}</h2>

            <p className="text-center">ReactJs, Flask, Github, SonarQube, REST api, JWT, Firestore, Firebase authentification</p>

            <h2 className="text-center titles text-pink-200">{t("pictures")}</h2>

            <Gallery images={[sweetaichat1,sweetaichat2]}/>
        </Dialog>
    )
}